import { TargetSchemaItem } from '../authentication-method-policy-utlity';
import {
    AuthenticationMethodsTemporaryAccessPassSchema,
    TemporaryAccessPassAuthenticationMethodConfigurationForm,
} from './model';

export function updateAuthenticationMethodsTemporaryAccessPassSchema(
    form: TemporaryAccessPassAuthenticationMethodConfigurationForm,
): AuthenticationMethodsTemporaryAccessPassSchema {
    // If state is disabled, only return state property
    if (form.state === 'disabled') {
        return {
            type: 'object',
            properties: {
                state: { type: 'string', const: form.state },
            },
        };
    }

    let includedTargetsOneOfItems: TargetSchemaItem[] = [];

    includedTargetsOneOfItems = form.includeTargets.includedGroups.map((group) => ({
        properties: {
            id: { type: 'string', const: group.id },
            targetType: { type: 'string', const: 'group' },
        },
    }));

    const excludeTargetsOneOfItems: TargetSchemaItem[] = form.excludeTargets.map((group) => ({
        properties: {
            id: { type: 'string', const: group },
            targetType: { type: 'string', const: 'group' },
        },
    }));

    return {
        type: 'object',
        properties: {
            state: { type: 'string', const: form.state },
            minimumLifetimeInMinutes: { type: 'number', const: Number(form.minimumLifetimeInMinutes) },
            maximumLifetimeInMinutes: { type: 'number', const: Number(form.maximumLifetimeInMinutes) },
            defaultLifetimeInMinutes: { type: 'number', const: Number(form.defaultLifetimeInMinutes) },
            defaultLength: { type: 'number', const: Number(form.defaultLength) },
            isUsableOnce: { type: 'boolean', const: form.isUsableOnce },
            includeTargets:
                includedTargetsOneOfItems.length > 0
                    ? {
                          type: 'array',
                          items: {
                              type: 'object',
                              oneOf: includedTargetsOneOfItems,
                          },
                          minItems: includedTargetsOneOfItems.length,
                          maxItems: includedTargetsOneOfItems.length,
                      }
                    : {
                          type: 'array',
                          maxItems: 0,
                      },

            excludeTargets:
                excludeTargetsOneOfItems.length > 0
                    ? {
                          type: 'array',
                          items: {
                              type: 'object',
                              oneOf: excludeTargetsOneOfItems,
                          },
                          minItems: excludeTargetsOneOfItems.length,
                          maxItems: excludeTargetsOneOfItems.length,
                      }
                    : {
                          type: 'array',
                          maxItems: 0,
                      },
        },
    };
}
